import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=0e4057e9&scoped=true&"
import script from "./Buy.vue?vue&type=script&lang=js&"
export * from "./Buy.vue?vue&type=script&lang=js&"
import style0 from "./Buy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Buy.vue?vue&type=style&index=1&id=0e4057e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4057e9",
  null
  
)

export default component.exports